module.exports = __webpack_public_path__ + "img/layout-top.c15bcaca.svg";